import { ButtonProps, ModalViewFormSuccessProps } from '~types'

export const FORM_ERROR_VIEW: ModalViewFormSuccessProps = {
  title: 'Error',
  description: {
    html: '<p>Something went wrong. Please try again later.</p>'
  },
  ctas: [
    {
      id: 'form_error_button',
      componentName: 'Button',
      color: 'light',
      fill: 'hollow',
      justify: 'center',
      size: 'lg',
      isFullWidth: false,
      title: 'Close'
    } as ButtonProps
  ],
  iconName: 'exclamation_point',
  isErrorView: true
}
